// extracted by mini-css-extract-plugin
module.exports = {"mainForm":"GetLead_mainForm__18P-s","header":"GetLead_header__1bhfj","loginForm":"GetLead_loginForm__2SVWm","mainBtn":"GetLead_mainBtn__3frzu"};